import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setPageName } from "../../../actions";
import { DashboardLayout } from "../../../components/Layouts";
import { DefaultPageContent } from "../../../components/PageContent";
import { PageTitle } from "../../../components/PageContent/subs";
import { VOC_BTN_FILTERS } from "../../../constants/vocConstants";
import VocWebsiteFilters from "../../../components/Filters/Voc/VocWebsiteFilters";

const Some = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageName(""));
  }, [dispatch]);

  return (
    <DashboardLayout>
      <DefaultPageContent
        filter={<VocWebsiteFilters filterBtns={VOC_BTN_FILTERS} inComplete />}
        dataDocumentation=""
        lastDataRefresh={""}
        pageTitle={<PageTitle dataDocumentation="" />}
      >
        <div className="no-data-tile">This dashboard page is in development and will be available soon in CEDAR home</div>
      </DefaultPageContent>
    </DashboardLayout>
  );
};

export default Some;
